class TagsUtils {
  collectIds(tag) {
    let ids = [tag.id];
    // If the tag has children, collect their ids 
    if (Array.isArray(tag.children)) {
      for (let child of tag.children) {
        ids = ids.concat(this.collectIds(child));
      }
    }

    return ids;
  }
}

export default new TagsUtils();
